import React from 'react';
import TemplateOne from './template-one/TemplateOne';
import {
	BannerContent,
	CountdownSettings,
	SiteTimezone,
	TemplateDesign,
} from '../types';

interface TemplateRendererProps {
	/** Template from the library (components, variants, styles). */
	design: TemplateDesign;
	/** The banner's texts and links. */
	content: BannerContent;
	countdown: CountdownSettings;
	siteTimezone?: SiteTimezone;
	isPreview?: boolean;
	onClose?: () => void;
}

/**
 * Renders a banner. Every template in the library is built from the base
 * template's layout, so they all render through TemplateOne.
 *
 * @param props Banner design, content and countdown.
 */
const TemplateRenderer: React.FC< TemplateRendererProps > = ( props ) => (
	<TemplateOne { ...props } />
);

export default TemplateRenderer;
